<template>
  <div>
    <!-- PC, タブレット -->
    <div class="pc-block">

      <!-- プラン説明部分 -->
      <div class="planSelectPrepareBoxes">
        <!-- プラン1 -->
        <div class="planSelectDescBox isFlex lbCheckSelectSizeLeft" @click="selectPersonalPlan()">
          <div>
            <h4 class="planSelectDescBoxTitle">個人利用</h4>
          </div>
        </div>

        <!-- プラン2 -->
        <div class="planSelectDescBox isFlex corpolateBox lbCheckSelectSize" @click="selectCorporatePlan()">
          <div>
            <h4 class="planSelectDescBoxTitle corpolateTitle">法人利用</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- スマホ -->
    <div class="sp-block">
      <div class="mb20">
        <!-- プラン1 -->
        <div @click="selectPersonalPlan()" class="planSelectFormItems">
          <h4 class="planSelectDescBoxTitle">個人利用</h4>
        </div>

        <!-- プラン2 -->
        <div @click="selectCorporatePlan()" class="planSelectFormItems corpolateBox">
          <h4 class="planSelectDescBoxTitle corpolateTitle">法人利用</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'loggedIn'
    ],

    data () {
      return {
      }
    },

    methods: {
      selectPersonalPlan () {
        window.location.href = '/register/lb_plan_select?checkout=1'
      },

      selectCorporatePlan () {
        window.location.href = '/register/lb_plan_select?checkout=2'
      }
    },
  }
</script>

<style lang="scss" scoped>
  .is-hidden {display:none;}
  .disable {color:white !important;background-color:#CCCCCC !important;cursor:inherit;}
  .trial-limit {text-align:center;font-size:14px;}
  .trialBox {height: 60px;}
  .personalBox{border: 1px solid #0042bd;}
  .corpolateBox{border:1px solid #30876e;}
  .corpolateTitle{color:#30876e;}
</style>
